import { render } from "./CreateViewModal.vue?vue&type=template&id=62b3b31e&scoped=true"
import script from "./CreateViewModal.vue?vue&type=script&lang=js"
export * from "./CreateViewModal.vue?vue&type=script&lang=js"

import "./CreateViewModal.vue?vue&type=style&index=0&id=62b3b31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b3b31e"]])

export default __exports__